module.exports = __webpack_public_path__ + "./images/c48ab7c0cbd292a3f0c43c8a3fef6ce1.webp";